import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=a0b3e47a&scoped=true&"
import script from "./TaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b3e47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b3e47a')) {
      api.createRecord('a0b3e47a', component.options)
    } else {
      api.reload('a0b3e47a', component.options)
    }
    module.hot.accept("./TaskForm.vue?vue&type=template&id=a0b3e47a&scoped=true&", function () {
      api.rerender('a0b3e47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/form/advancedForm/TaskForm.vue"
export default component.exports